import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { path: '/', label: 'Home' },
    { path: '/ai-journey', label: 'AI for You' },
    { path: '/services', label: 'Transformation Services' },
    { path: '/about', label: 'About' },
    { path: '/youtube', label: 'YouTube' },
    { path: '/contact', label: 'Contact' }
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    const onEscape = (event) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener('keydown', onEscape);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onEscape);
    };
  }, [isMenuOpen]);

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <div className="logo-lines">
              <div className="logo-text">Saner</div>
              <div className="logo-accent">Consulting</div>
            </div>
          </Link>

          <div className="nav-area">
            <div className="nav-cta-row">
              <Link to="/contact#contact-form" className="nav-cta nav-cta-desktop">
                Book Consultation
              </Link>
            </div>
            <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
              <ul className="nav-list">
                {navigationItems.map((item) => (
                  <li key={item.path} className="nav-item">
                    <Link
                      to={item.path}
                      className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                      aria-current={location.pathname === item.path ? 'page' : undefined}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
                <li className="nav-item nav-item-cta-mobile">
                  <Link to="/contact#contact-form" className="nav-cta">
                    Book Consultation
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          <button
            className={`menu-toggle ${isMenuOpen ? 'menu-open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
      {isMenuOpen && <button className="nav-overlay" aria-label="Close menu overlay" onClick={() => setIsMenuOpen(false)} />}
    </header>
  );
};

export default Header;
